import React, { FC } from 'react';

interface IError {
  error: any;
}

export const Error: FC<IError> = ({ error }) => {
  return <>Error occured </>;
};
